// extracted by mini-css-extract-plugin
module.exports = {"userDetails":"styles_userDetails__1rGer","withoutMarginBottom":"styles_withoutMarginBottom__2cp6T","firstRow":"styles_firstRow__na1ak"};